// Processing indicator component.
//
// Shows a loading spinner with optional progress percentage and status message.
//

interface ProcessingIndicatorProps {
  progress?: number;
  message?: string;
  className?: string;
}

// Processing indicator with spinner and optional progress.
//
export function ProcessingIndicator({
  progress,
  message = "Processing...",
  className = "",
}: ProcessingIndicatorProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 ${className}`}
    >
      {/* Spinner */}
      <div className="border-border border-t-primary h-12 w-12 animate-spin rounded-full border-4" />

      {/* Message */}
      <p className="text-muted-foreground text-lg">{message}</p>

      {/* Progress bar */}
      {progress !== undefined && (
        <div className="w-full max-w-xs">
          <div className="bg-accent h-2 overflow-hidden rounded-full">
            <div
              className="bg-primary h-full rounded-full transition-all duration-300"
              style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
            />
          </div>
          <p className="text-muted-foreground mt-1 text-center text-sm">
            {Math.round(progress)}%
          </p>
        </div>
      )}
    </div>
  );
}
